'use strict';

import baseConfig from './base';

let config = {
  apiUrl: 'https://api.pingsta.com/api/v1',
  debugInfoEnabled: false,
  mysolvrUrl: 'https://mysolvr.com',
  mapbox: {
    id: 'ckk6x0nav0hd217ltq2kduf7t',
    account: 'postworld',
    accessToken: 'pk.eyJ1IjoicG9zdHdvcmxkIiwiYSI6IlpWSTdDZTQifQ.ylBSjqZlV3rox1pZF-PHsQ'
  }
};

export default Object.freeze(Object.assign({}, baseConfig, config));



// WEBPACK FOOTER //
// ./src/config/dist.js